import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchBranchMasterAPI } from '../../../api/commonApi';

export const fetchBranchMaster = createAsyncThunk(
  'branch/fetchBranchMaster',
  async (vendorId, { rejectWithValue }) => {
    try {
      const response = await fetchBranchMasterAPI(vendorId);
      return response.data.branchMasterData;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

